import { render, staticRenderFns } from "./platBroad.vue?vue&type=template&id=6ed5d37a&scoped=true"
import script from "./platBroad.vue?vue&type=script&lang=js"
export * from "./platBroad.vue?vue&type=script&lang=js"
import style0 from "./platBroad.vue?vue&type=style&index=0&id=6ed5d37a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5d37a",
  null
  
)

export default component.exports